<template lang="pug">
  b-modal#updateCMMMO(
    ref="updateCMMMO"
    :title="$t('ui.combine.update_commission')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="md"
    @ok="done"
    @show="reset"
    @shown="shown"
    :hide-footer="!$helpers.getVisible(editLimit)"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      span #[b {{ $t("ui.account_id") + " : " + accountId.toUpperCase() }}]
      #tblModal.table-sm.table-responsive.commission
        table.table.table-bordered
          tbody
            tr
              th {{ comm_hdp_mmo_title }}
              td
                PTSelect(
                  ref="comm_hdp_mmo"
                  :dirty="$v.comm_hdp_mmo.$dirty"
                  :error="$v.comm_hdp_mmo.$error"
                  :options="comm_hdp_mmo_options"
                  v-model="$v.comm_hdp_mmo.$model"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
            tr
              th {{ comm_parlay_mmo_a_title }}
              td
                PTSelect(
                  ref="comm_parlay_mmo_a"
                  :dirty="$v.comm_parlay_mmo_a.$dirty"
                  :error="$v.comm_parlay_mmo_a.$error"
                  :options="comm_parlay_mmo_a_options"
                  v-model="$v.comm_parlay_mmo_a.$model"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
            tr
              th {{ comm_parlay_mmo_b_title }}
              td
                PTSelect(
                  ref="comm_parlay_mmo_b"
                  :dirty="$v.comm_parlay_mmo_b.$dirty"
                  :error="$v.comm_parlay_mmo_b.$error"
                  :options="comm_parlay_mmo_b_options"
                  v-model="$v.comm_parlay_mmo_b.$model"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import { required, maxValue } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    PTSelect,
    SubmitButton
  },
  props: {
    accountId: ""
  },
  data() {
    return {
      loading: false,
      comm_hdp_mmo: 0,
      comm_parlay_mmo_a: 0,
      comm_parlay_mmo_b: 0,
      cmJSON: {
        hdp: 0,
        parlay_a: 0,
        parlay_b: 0
      },
      submission: {
        success: true,
        status: ""
      }
    }
  },
  validations: {
    comm_hdp_mmo: {
      required,
      maxValue(value) {
        return maxValue(this.comm_hdp_mmo_max)(value)
      }
    },
    comm_parlay_mmo_a: {
      required,
      maxValue(value) {
        return maxValue(this.comm_parlay_mmo_a_max)(value)
      }
    },
    comm_parlay_mmo_b: {
      required,
      maxValue(value) {
        return maxValue(this.comm_parlay_mmo_b_max)(value)
      }
    }
  },
  computed: {
    editLimit: function() {
      return [config.accessRoles.editLimit]
    },
    comm_hdp_mmo_title: function() {
      return this.$t("ui.hdp") + "/" + this.$t("ui.ou") + " (" + this.comm_hdp_mmo_max + ")"
    },
    comm_hdp_mmo_max: function() {
      if(this.$store.getters.getCommMMO){
        return ['MMK','MMO'].includes(this.$store.getters.getAccountCurrency) ? 2 : 0
      }
    },
    comm_hdp_mmo_options: function() {
      return this.$helpers.getCommRateList1(this.comm_hdp_mmo_max, this.comm_hdp_mmo)
    },
    comm_parlay_mmo_a_title: function() {
      return this.$t("ui.combine.comm_parlay_mmo_a") + " (" + this.comm_parlay_mmo_a_max + ")"
    },
    comm_parlay_mmo_a_max: function() {
      if(this.$store.getters.getCommMMO){
        return ['MMK','MMO'].includes(this.$store.getters.getAccountCurrency) ? 7 : 0
      }
    },
    comm_parlay_mmo_a_options: function() {
      return this.$helpers.getCommRateList1(this.comm_parlay_mmo_a_max, this.comm_parlay_mmo_a)
    },
    comm_parlay_mmo_b_title: function() {
      return this.$t("ui.combine.comm_parlay_mmo_b") + " (" + this.comm_parlay_mmo_b_max + ")"
    },
    comm_parlay_mmo_b_max: function() {
      if(this.$store.getters.getCommMMO){
        return ['MMK','MMO'].includes(this.$store.getters.getAccountCurrency) ? 15 : 0
      }
    },
    comm_parlay_mmo_b_options: function() {
      return this.$helpers.getCommRateList1(this.comm_parlay_mmo_b_max, this.comm_parlay_mmo_b)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault()
      this.submit()
    },
    getChildCommission: function() {
      $("select").prop("disabled", !this.$helpers.getVisible(this.editLimit))
      let account_id = this.accountId
      let platform_code = "SPORTSBOOK"
      if(account_id) {
        this.$store
        .dispatch("user/getChildCommission", { account_id, platform_code })
        .then(response => {
          this.$v.comm_hdp_mmo.$model = response.data.cmMMO[0].hdp
          this.$v.comm_parlay_mmo_a.$model = response.data.cmMMO[0].parlay_a
          this.$v.comm_parlay_mmo_b.$model = response.data.cmMMO[0].parlay_b
          $("select").prop("disabled", !this.$helpers.getVisible(this.editLimit))
        })
        .catch(response => {
        });
      } else {
        this.cancel()
      }
    },
    submit: function() {
      // this.reset()
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_account_commission_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updateCommMMO()
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_account_commission_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    updateCommMMO: function() {
      let account_id = this.accountId
      this.cmJSON.hdp = this.comm_hdp_mmo
      this.cmJSON.parlay_a = this.comm_parlay_mmo_a
      this.cmJSON.parlay_b = this.comm_parlay_mmo_b
      let cm = this.cmJSON
      this.$store
        .dispatch("user/updateCommissionMMO", { account_id, cm })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.update_account_commission_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          // console.log("Failed:updateCommissionLT", response)
          this.loading = false;
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.comm_hdp_mmo = 0
      this.comm_parlay_mmo_a = 0
      this.comm_parlay_mmo_b = 0
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset()
        this.$helpers.getCommission()
        this.getChildCommission()
      });
    },
    cancel: function() {
      // this.$emit("clicked")
      this.$refs.updateCMMMO.hide()
    }
  }
};
</script>

